var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { createNewStageRequest, editStageRequest } from "../../../api/api";
import { CLOSE_STAGE_MODAL, PIPELINE_ADD_STAGE, PIPELINE_EDIT_STAGE, } from "../../../constants";
import { DispatchType, useModal } from "../../../hooks/useModal";
import { ModalContext } from "../../../providers/ModalContextProvider";
import { WPQTModal } from "../WPQTModal";
import { StageModalContent } from "./StageModalContent";
function StageModal() {
    const { state: { stageModalOpen, targetPipelineId }, } = useContext(ModalContext);
    const { modalSaving, setModalSaving, modalContentRef, closeModal, handleSuccess, handleError, } = useModal(CLOSE_STAGE_MODAL);
    const addStage = (stageName, stageDescription) => __awaiter(this, void 0, void 0, function* () {
        try {
            setModalSaving(true);
            const response = yield createNewStageRequest(targetPipelineId, stageName, stageDescription);
            handleSuccess(PIPELINE_ADD_STAGE, Object.assign(Object.assign({}, response.data), { tasks: [] }), DispatchType.ACTIVE_PIPELINE);
        }
        catch (error) {
            handleError(error);
        }
    });
    const editStage = (stage) => __awaiter(this, void 0, void 0, function* () {
        try {
            setModalSaving(true);
            const response = yield editStageRequest(stage);
            handleSuccess(PIPELINE_EDIT_STAGE, response.data, DispatchType.ACTIVE_PIPELINE);
        }
        catch (error) {
            handleError(error);
        }
    });
    return (_jsx(WPQTModal, { modalOpen: stageModalOpen, closeModal: closeModal, children: _jsx(StageModalContent, { ref: modalContentRef, editStage: editStage, addStage: addStage, stageModalSaving: modalSaving, stageTaskModalSaving: setModalSaving }) }));
}
export { StageModal };
